import React from 'react'
import TopHeader from '../components/ServiceDetails/TopHeader'
import PageBanner from '../components/Common/PageBanner'
import Footer from '../components/ServiceDetails/Footer'
import ContactForm from '../components/ServiceDetails/ContactForm'
import imgService from '../components/App/assets/images/services/SLCSlopes.jpg'

const ServiceDetails = () => {
    return (
        <React.Fragment>  
            <TopHeader />
            <PageBanner 
                bgText="Web Design Salt lake City" 
                pageTitle="Web Design Salt lake City" 
                homePageUrl="charliejergins.com" 
                homePageText="Home" 
                activePageText="Salt Lake City" 
            /> 

            <div id="service-details" className="service-details-area pt-100 pb-70">
                <div className="container">
                    <div className="details-item">
                        <img src={imgService} alt="Details" />
                        
                        <div className="contact-area">
                            <div className="container">
                                <div className="section-title">
                                    <h2>Do You Have A Project? Just <span>Drop A Line</span>. I Want To Hear From You</h2>
                                </div>

                                <div className="row align-items-center">
                                    <div className="col-lg-7">
                                        <ContactForm />
                                    </div>

                                    <div className="col-lg-5">
                                        <div className="contact-content">
                                            <div className="top">
                                                <ul>
                                                    <li>
                                                        <span>Phone:</span>
                                                        <a href="tel:+18019894888">+1(801)989-4888</a>
                                                    </li>
                                                    <li>
                                                        <span>Email:</span>
                                                        <a href="mailto:JerginsCharlie@gmail.com">JerginsCharlie@Gmail.com</a>
                                                    </li>
                                                    
                                                </ul>
                                            </div>

                                            <div className="bottom">
                                                <ul>
                                                    <li>
                                                        <a href="https://github.com/charlesbadjr" target="_blank" rel="noreferrer" >
                                                            <i className='bx bxl-github'></i>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://twitter.com/chuckJergins" target="_blank" rel="noreferrer">
                                                            <i className='bx bxl-twitter'></i>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.linkedin.com/in/charlie-jergins/" target="_blank" rel="noreferrer" >
                                                            <i className='bx bxl-linkedin'></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
 
            <Footer />
        </React.Fragment>
    )
}

export default ServiceDetails